import React, { PureComponent } from "react";
import { Card, Badge, CustomInput } from "reactstrap";
import { connect } from "react-redux";
import {
  setContainerClassnames,
  clickOnMobileMenu,
} from "../../../redux/actions";

class LabelItemLeft extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {};
  }

  menuButtonClick = (e, menuClickCount, containerClassnames) => {
    setTimeout(() => {
      var event = document.createEvent("HTMLEvents");
      event.initEvent("resize", false, false);
      window.dispatchEvent(event);
    }, 350);
    this.props.setContainerClassnames(
      menuClickCount,
      containerClassnames,
      this.props.selectedMenuHasSubItems,
    );
  };

  onClickedItem = (item) => {
    this.props.onClickedItem(item, this.menuButtonClick, [
      null,
      1000,
      this.props.containerClassnames,
    ]);
  };

  formatDate = (dateStr) => {
    if (!dateStr) return "";
    const d = new Date(dateStr);
    return d.toLocaleDateString("vi-VN", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
    });
  };

  render() {
    const { item, selectedItems, onChangeCheckbox } = this.props;
    const productCount =
      item.productCount || item.dataValues?.productCount || 0;

    return (
      <Card className="mb-3 custom-shadow">
        <div className="d-flex flex-row cursor-pointer">
          <div
            className="d-flex flex-grow-1 min-width-zero"
            onClick={() => this.props.onClickedItem(item)}
          >
            <div className="card-body w-100 align-self-center d-flex flex-column flex-lg-row justify-content-between min-width-zero align-items-lg-center">
              {/* Category Name */}
              <div className="list-item-heading mb-1 mb-lg-0 truncate d-block w-lg-40">
                <span className="text-capitalize">{item.name}</span>
              </div>

              {/* Product Count & Created Date */}
              <div className="d-flex align-items-center mb-1 mb-lg-0">
                <Badge color="primary" pill className="mr-2">
                  {parseInt(productCount, 10)} sản phẩm
                </Badge>
              </div>
            </div>
          </div>
          <div
            className="pl-1 align-self-center pr-4"
            onClick={(e) => e.stopPropagation()}
          >
            <span className="text-muted text-small">
              {/* <i className="simple-icon-calendar mr-1" /> */}
              {this.formatDate(item.createdAt)}
            </span>
            {/* <CustomInput
              className="item-check mb-0"
              type="checkbox"
              id={`check-${item.id}`}
              checked={selectedItems.includes(item.id)}
              onChange={() => onChangeCheckbox(item.id)}
              label=""
            /> */}
          </div>
        </div>
      </Card>
    );
  }
}

const mapStateToProps = ({ menu }) => {
  const { containerClassnames, menuClickCount, selectedMenuHasSubItems } = menu;
  return {
    containerClassnames,
    menuClickCount,
    selectedMenuHasSubItems,
  };
};
export default connect(mapStateToProps, {
  setContainerClassnames,
  clickOnMobileMenu,
})(LabelItemLeft);
